import type { BuildableWithProps, PropsRouteBuilder } from './router';
import type { TripPlannerProperties, TripPlannerQueryString } from './model';
import { parseRecipe } from './parseRecipe';

export function buildRouteQuery(
  propsRouteBuilder: PropsRouteBuilder
): BuildableWithProps<TripPlannerQueryString> {
  return propsRouteBuilder
    .hasProps<TripPlannerProperties>(() => ({
      initialIngredients: [],
      initialPax: [{ numberOfAdults: 2 }],
    }))
    .mappedToQuery<TripPlannerQueryString>(parseRecipe);
}
